<template>
	<view class="settings-page">
		<view class="avatar-section">
			<image class="avatar-image" src="/static/image/tx@2x.png" mode="aspectFill"></image>
			<view class="change-avatar-btn">更换头像</view>
		</view>

		<view class="settings-list">
			<view v-for="item in settingsList" :key="item.label" class="settings-row">
				<text class="row-label">{{ item.label }}</text>
				<view class="row-right">
					<text class="row-value" :class="{ placeholder: !item.value }">{{ item.value || item.placeholder }}</text>
					<u-icon name="arrow-right" size="18" color="#B8BDC6"></u-icon>
				</view>
			</view>
		</view>

		<view class="logout-wrap">
			<view class="logout-btn">退出登录</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				settingsList: [
					{ label: '昵称', value: '', placeholder: '请输入' },
					{ label: '真实姓名', value: '', placeholder: '请输入' },
					{ label: '绑定手机', value: '181****9990', placeholder: '' },
					{ label: '收货地址', value: '', placeholder: '' },
					{ label: '协议与说明', value: '', placeholder: '' }
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.settings-page {
		background: #ffffff;
		padding: 0 30rpx;
		box-sizing: border-box;
	}

	.avatar-section {
		margin-top: 40rpx;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.avatar-image {
		width: 160rpx;
		height: 160rpx;
		border-radius: 50%;
		overflow: hidden;
	}

	.change-avatar-btn {
		width: 136rpx;
		height: 48rpx;
		border-radius: 32rpx;
		border: 1rpx solid #10B2FA;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 26rpx;
		color: #10B2FA;
		margin-top: 24rpx;
	}

	.settings-list {
		margin-top: 56rpx;
	}

	.settings-row {
		height: 98rpx;
		border-bottom: 1rpx solid #E5E5E5;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.row-label {
		font-weight: 400;
		font-size: 30rpx;
		color: #111111;
	}

	.row-right {
		display: flex;
		align-items: center;
		gap: 8rpx;
	}

	.row-value {
		font-weight: 400;
		font-size: 28rpx;
		color: #111111;
	}

	.row-value.placeholder {
		font-weight: 400;
		font-size: 28rpx;
		color: #999999;
	}

	.logout-wrap {
		position: fixed;
		bottom: calc(40rpx + env(safe-area-inset-bottom));
		left: 30rpx;
		width: calc(100% - 60rpx);
		display: flex;
		justify-content: center;
	}

	.logout-btn {
		width: 200rpx;
		height: 72rpx;
		border-radius: 36rpx;
		border: 1rpx solid #999999;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: 400;
		font-size: 28rpx;
		color: #333333;
		box-sizing: border-box;
	}
</style>
